import { z } from 'zod';

export const rewriteRouteSchema = z.object({
  startsWith: z.string(),
  redirectB2B: z.boolean(),
  addWAFHeader: z.boolean(),
  destination: z.string(),
});

export type RewriteRoute = z.infer<typeof rewriteRouteSchema>;
